import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modules } from '@app/core/enums';
import { NgShortcut, NgShortcutService } from '@app/core/sharedmodules/ng-shortcut';

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
})
export class ButtonsComponent {
  @Output()
  readonly triggerOnSaveClick = new EventEmitter<{
    isExit: boolean;
    isSaveAndSubmit?: boolean;
    isSaveAndInvite?: boolean;
  }>();

  @Output()
  readonly triggerOnCancelClick = new EventEmitter<any>();

  @Output()
  readonly triggerOnRollSaveClick = new EventEmitter<any>();

  moduleEnum = Modules;
  @Input() getModuleId: number;
  @Input() getRollForward?: boolean;
  modules = Modules;
  constructor(private ngShortcutService: NgShortcutService) {
    ngShortcutService.push(
      new NgShortcut('s', () => this.onSave(false), {
        preventDefault: true,
        ctrlKey: true,
      })
    );

    ngShortcutService.push(
      new NgShortcut('e', () => this.onSave(true), {
        preventDefault: true,
        ctrlKey: true,
      })
    );

    ngShortcutService.push(
      new NgShortcut('x', () => this.onCancel(), {
        preventDefault: true,
        ctrlKey: true,
      })
    );
  }

  onSave(
    isExit: boolean,
    isSaveAndSubmit?: boolean,
    isSaveAndInvite?: boolean
  ): void {
    this.triggerOnSaveClick.next({ isExit, isSaveAndSubmit, isSaveAndInvite });
  }

  onCancel(): void {
    this.triggerOnCancelClick.emit(false);
  }

  onRollSave(): void {
    this.triggerOnRollSaveClick.emit(true);
  }
}
